import "bootstrap/dist/css/bootstrap.min.css";
import React from "react";
import ReactDOM from "react-dom/client";
import { AuthProvider } from "react-oidc-context";
import { Provider } from "react-redux";
import { BrowserRouter as Router } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import App from "./App.jsx";
import LoginSuccess from "./components/login/linkedin-callback.jsx";
import { OIDC_CONFIG } from "./constants/baseUrl";
import { AuthProvider as CustomAuthProvider } from "./helper/auth/AuthProviderContext";
import "./index.css";
import AuthPage from "./pages/auth/auth";
import reportWebVitals from "./reportWebVitals";
import { store } from "./states/store";
import { getCookie } from "./utils/cookies.js";

const root = ReactDOM.createRoot(document.getElementById("root"));
const token = getCookie("token");
const isValidUser = localStorage.getItem("isValidUser");

root.render(
  <React.StrictMode>
    <Router>
      <AuthProvider {...OIDC_CONFIG}>
        <Provider store={store}>
          <CustomAuthProvider>
            {window.location.pathname.indexOf("loginsuccess") > -1 ? (
              <LoginSuccess />
            ) : (isValidUser === true || isValidUser === "true") && token ? (
              <App />
            ) : (
              <AuthPage />
            )}
            <ToastContainer
              limit={1}
              autoClose={2500}
              draggable
              hideProgressBar
              position="bottom-right"
              bodyStyle={{
                fontSize: "12px",
                margintop: "0px",
                marginbottom: "0px",
              }}
            />
          </CustomAuthProvider>
        </Provider>
      </AuthProvider>
    </Router>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
